import { useEffect } from "react";
import { getSessionCryptofacil, getUserCryptofacil } from "../services/utils/StorageUtils";
import useStore from "../services/store/useStore";

export const useGetSessionCryptofacil = () => {
    const userData = useStore(state => state.user);
    const setUserData = useStore(state => state.setUserData);

    const sessionStorage = getSessionCryptofacil();
    const userStorage = getUserCryptofacil();

    useEffect(() => {
        if (!userData && userStorage && sessionStorage) {
            setUserData(JSON.parse(userStorage));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sessionStorage, userData, userStorage]);
};
